import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import { login } from "src/api/auth";
import { userRoles } from "src/constants/constants";
import { isUserSeller, getUserRoleIds } from "src/constants/user_constants";
import { GlobalContext } from "src/context/GlobalState";

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const {
    dispatch,
    state: { globalState }
  } = useContext(GlobalContext);

  const handleClick = async () => {
    try {
      const body = { emailId: globalState.email, password: globalState.password };

      const data = await login(body);

      if (data.httpStatusCode === 200) {
        const token = data.result.data.accessToken;

        const roleIds = getUserRoleIds(data.result.data);
        const hasDriverRole = roleIds.includes(userRoles.driver);
        const hasAdminRole = roleIds.includes(userRoles.admin);

        const activeRoleId =
          hasDriverRole && hasAdminRole ? userRoles.admin : data.result.data.roleId;
        const user = { ...data.result.data, roleId: activeRoleId };

        dispatch({ type: "userData", payload: user });
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);

        if (hasDriverRole && !hasAdminRole) {
          navigate("/dashboard/driver", { replace: true });
          return;
        }
        const isSeller = isUserSeller(user);
        if (user.firstTimeLogin && isSeller) {
          navigate("/reset-password", { replace: true });
          return;
        } else {
          const redirectPath = localStorage.getItem("redirectAfterLogin") || "/dashboard/products";
          localStorage.removeItem("redirectAfterLogin");
          navigate(redirectPath, { replace: true });
        }
      } else {
        alert(data.message);
      }
    } catch (error) {}
    // navigate('/dashboard', { replace: true });
  };

  return (
    <div className="space-y-5">
      <div>
        <label className="block mb-1 font-medium">Email address</label>
        <input
          type="email"
          className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
          value={globalState.email}
          onChange={(e) => dispatch({ type: "email", payload: e.target.value })}
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Password</label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            value={globalState.password}
            onChange={(e) => dispatch({ type: "password", payload: e.target.value })}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-3 flex items-center text-gray-500"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "👁️"}
          </button>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <label className="flex items-center space-x-2">
          <input type="checkbox" defaultChecked className="h-4 w-4" />
          <span>Remember me</span>
        </label>
      </div>

      <button
        onClick={handleClick}
        className="w-full bg-orange-500 text-white py-2 rounded hover:bg-orange-600 transition"
      >
        Sign In
      </button>
    </div>
  );
}
